import React, { createContext, useState, useContext } from 'react';
import { translations } from '../translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    // Default language is Hindi
    const [language, setLanguage] = useState('hi');

    const t = (key, params = {}) => {
        let text =
            translations[language]?.[key] ||
            translations.en?.[key] ||
            key;
    
        Object.keys(params).forEach((param) => {
            text = text.replace(
                new RegExp(`\\$\\{${param}\\}`, "g"),
                params[param]
            );
        });
    
        return text;
    };

    const toggleLanguage = (lang) => {
        if (translations[lang]) {
            setLanguage(lang);
        }
    };

    return (
        <LanguageContext.Provider
            value={{
                language,
                setLanguage: toggleLanguage,
                t
            }}
        >
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);